import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import session from '../../../../../share/session';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../../share/util/api/polling';
import { checkIsCompressed } from './checkIsCompressed';
import { terminate } from './terminate';
import { PHASE, IMAGE_SIZE } from './constants';

/**
 * 選択された項目について圧縮有無確認、プレビューデータ読み出しを実行する
 * @param {object} self this インスタンス
 */
export async function readPreviewImages(self) {
  try {
    self.isLoading = true;
    // 圧縮有無確認を実施
    await checkIsCompressed(self);
    const userData = await readPreview(self);
    if (userData.is_preprocess_failed) {
      await terminate(self, PHASE.PREVIEW_FAILED);
      return;
    }
    self.imageData = userData.image_data;
    self.phase = PHASE.PREVIEW_DISPLAY;
    self.$nextTick(async () => {
      const refNames = Object.keys(self.imageData);
      for (const name of refNames) {
        await renderFromRGBAList(self, name);
      }
    });
  } catch (error) {
    await self.validateErrorResult(error);
  } finally {
    self.isLoading = false;
  }
}

/**
 * プレビューデータ読み出し
 * @param {object} self this インスタンス
 * @returns {object} user_data
 */
async function readPreview(self) {
  try {
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        is_special: true,
        type: 'read_preview',
        image_type: self.selectedPreviewItem.image_type,
        image_order: self.selectedDateItem.image_order,
        is_compressed: self.isCompressed
      },
      // エラー発生のコールバック
      async (errorType) => { errorType; return ''; },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async () => { return ''; },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async () => { return ''; }
    );

    if (response) {
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          return response.data.user_data;
        case REQUEST_STATUS_FAILED:
        default:
          throw new Error("Request failed");
      }
    } else {
      throw new Error("No response received");
    }
  } catch {
    throw new Error("No response received");
  }
}

/**
 * プレビュー画像作成
 * @param {object} self this インスタンス
 * @param {string} refName 参照する画像名(first_image等)
 */
async function renderFromRGBAList(self, refName) {
  try {
    // Vue の $refs から対象の <canvas> 要素を取得
    const canvas = self.$refs[refName];
    // 2D 描画コンテキストを取得
    const ctx = canvas.getContext('2d');
    const rgbaArray = self.imageData[refName];
    // Canvas ImageData は Uint8ClampedArray を要求するため、該当型に変換
    const rgba = new Uint8ClampedArray(rgbaArray);
    // ImageData からブラウザ最適化されたビットマップを生成（非同期）
    const imgData = new ImageData(rgba, IMAGE_SIZE.WIDTH, IMAGE_SIZE.HEIGHT);
    const bmp = await createImageBitmap(imgData);
    // 座標(0,0) を左上として、キャンバス全面にフィットさせる
    ctx.drawImage(bmp, 0, 0, canvas.width, canvas.height);
  } catch {
    throw new Error("Failed to draw image");
  }
}